import { SanityMarketingAboutFund, SanityMarketingCaseStudy } from 'types/sanity/marketing-components';
import { useQueryWithContext, villusClient } from '@utils/villus';
import {
	VentureMarketingPageAboutTheFundQuery,
	VentureMarketingPageCaseStudyQuery,
	VentureMarketingPageQuery
} from '@sanity/graphql/queries/venture-marketing-page';
import { flattenSharedFooterDisclaimers } from '@utils/sanity';
import { SanityGraphQLResponse } from 'types/sanity';
import { useQuery } from 'villus';
import { VentureMarketingPage } from 'types/sanity/venture-marketing';

type SanityVentureMarketingPageResponse = SanityGraphQLResponse<VentureMarketingPage, 'allVentureMarketingSitePage'>;

export async function getVentureMarketingPage(context?: string): Promise<VentureMarketingPage | null> {
	const { data } = await useQueryWithContext<SanityVentureMarketingPageResponse>({
		client: villusClient,
		query: VentureMarketingPageQuery,
		baseTag: 'venture_marketing_page',
		contextTag: context
	}).execute();

	const ventureMarketingPage = data?.allVentureMarketingSitePage[0];
	const footerDisclaimers = ventureMarketingPage?.footerDisclaimers ?? [];

	if (ventureMarketingPage && footerDisclaimers.length > 0) {
		ventureMarketingPage.flatFooterDisclaimers = flattenSharedFooterDisclaimers(footerDisclaimers);
	}

	return ventureMarketingPage ?? null;
}

export async function getVentureMarketingPageCaseStudy(): Promise<SanityMarketingCaseStudy | null> {
	const { data } = await useQuery<SanityVentureMarketingPageResponse>({
		client: villusClient,
		query: VentureMarketingPageCaseStudyQuery,
		tags: ['venture_marketing_page_case_study']
	}).execute();

	return data?.allVentureMarketingSitePage[0].caseStudyPanel ?? null;
}

export async function getVentureMarketingPageFeaturedFund(): Promise<SanityMarketingAboutFund | null> {
	const { data } = await useQuery<SanityVentureMarketingPageResponse>({
		client: villusClient,
		query: VentureMarketingPageAboutTheFundQuery,
		tags: ['venture_marketing_page_featured_fund']
	}).execute();

	return data?.allVentureMarketingSitePage[0] ?? null;
}
